import * as React from 'react'
// CComponents
import Input from '@frontrow/console/src/entities/components/base/input'
import {Button} from '@frontrow/console/src/components/button'
import {Label} from '@frontrow/console/src/components/ui/label'
import {LanguageDropdown} from '@frontrow/console/src/components/teacher-language-dropdown/index'
import {type LangT} from '@frontrow/console/src/entities/helpers/languages'

// Models
import {
  type DetailedSchoolAdminT,
  type SchoolAdminUpdateT,
  mkSchoolAdminUpdate
} from '@frontrow/console/src/models/school-admin'
// Components'
import FormField from '@frontrow/console/src/components/common/form-field'
// Styles
import * as style from '@frontrow/console/src/components/pages/school-admins-page/school-admin-form/school-admin-form.module.scss'

type Props = {
  onCancel: () => void
  onSubmit: (newSchoolAdminData: SchoolAdminUpdateT) => void
  schoolAdminToUpdate: DetailedSchoolAdminT
}

export default function SchoolAdminForm(props: Props): React.ReactElement {
  const {onCancel, onSubmit, schoolAdminToUpdate} = props

  const [formData, setFormData] = React.useState<DetailedSchoolAdminT>({
    ...schoolAdminToUpdate
  })

  const updateStringField = (field: string): ((val: string) => void) => {
    return (newValue: string) => {
      setFormData(prevState => ({
        ...prevState,
        [field]: newValue
      }))
    }
  }

  const setLanguage = (newLanguage: LangT) => {
    setFormData(prevState => ({...prevState, language: newLanguage}))
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit(mkSchoolAdminUpdate({old: schoolAdminToUpdate, updated: formData}))
  }

  const onToggleConfirmed = () => {
    setFormData(prevState => ({
      ...prevState,
      confirmed: !prevState.confirmed
    }))
  }

  const {confirmed, firstName, lastName, language} = formData

  return (
    <form onSubmit={handleSubmit} action="">
      <div className={style.schoolAdminFormContainer}>
        <div className={style.schoolAdminDetailsContainer}>
          <FormField wrapperStyle={style.schoolAdminGenericFieldContainer} label="First Name">
            <Input
              value={firstName}
              type="text"
              required
              placeholder={schoolAdminToUpdate.firstName}
              onChange={updateStringField('firstName')}
            />
          </FormField>
          <FormField wrapperStyle={style.schoolAdminGenericFieldContainer} label="Last Name">
            <Input
              value={lastName}
              type="text"
              required
              placeholder={schoolAdminToUpdate.lastName}
              onChange={updateStringField('lastName')}
            />
          </FormField>
          <FormField wrapperStyle={style.schoolAdminGenericFieldContainer} label="Language">
            <LanguageDropdown
              updateMode={{tag: 'component-is-passthrough'}}
              labels={{loadingText: 'Loading'}}
              selectedLanguage={language}
              onChange={setLanguage}
            />
          </FormField>
          <div
            className={`${style.schoolAdminFullFieldContainer} ${style.schoolAdminConfirmCheckBoxContainer}`}
          >
            <Label>Confirmed</Label>
            <input type="checkbox" checked={confirmed} onChange={onToggleConfirmed} />
          </div>
        </div>
      </div>
      <div className={style.schoolAdminFormButtonContainer}>
        <Button style="secondary" addClass={style.schoolAdminFormCancel} onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Update School Admin</Button>
      </div>
    </form>
  )
}
